// src/api/auth.js
import API from "../axiosConfig";

export const getFilterTransaction = async (filter) => {
  try {
    const response = await API.get("/transactions/get/filter-trans", {
      params: filter,
    });
    return response.data; // Adjust based on your API response structure
  } catch (error) {
    throw error; // Rethrow error to be handled in the component
  }
};

export const externalTransferBalance = async (payload) => {
  try {
    const response = await API.post("/transactions/external-transfer", {
      ...payload,
    });
    return response.data; // Adjust based on your API response structure
  } catch (error) {
    throw error; // Rethrow error to be handled in the component
  }
};

export const getTotalCmiPayments = async () => {
  try {
    const response = await API.get("/transactions/get/total-cmi-payments");
    return response.data; // Returns { total: number }
  } catch (error) {
    throw error;
  }
};

export const getTotalFatouratiPayments = async () => {
  try {
    const response = await API.get("/transactions/get/total-fatourati-payments");
    return response.data; // Returns { total: number }
  } catch (error) {
    throw error;
  }
};

export const resetTotalCmiPayments = async () => {
  try {
    const response = await API.post("/transactions/reset/total-cmi-payments");
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const resetTotalFatouratiPayments = async () => {
  try {
    const response = await API.post("/transactions/reset/total-fatourati-payments");
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getTotalCmiFatouratiAllPayments = async () => {
  try {
    const response = await API.get("/transactions/get/total-cmi-fatourati-all");
    return response.data;
  } catch (error) {
    throw error;
  }
};
